import React from "react";
import Card from "../../components/page/Card";
import ModelosDataTable from "./Modelos/ModelosDataTable";
import MensagensApiClient from "../../api/mensagens";
import useApi from "../../hooks/useApi";
import CommonsHelper from "../../helpers/CommonsHelper";
import ModeloModal from "./Modelos/ModeloModal";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import emojiToolkit from "emoji-toolkit";

function Modelos() {
  const [modelos, setModelos] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [modeloModal, setModeloModal] = React.useState(false);
  const [novo, setNovo] = React.useState(false);

  const { request: getModelos, data: modelosResponse } = useApi(
    MensagensApiClient.getModelos
  );
  const postModeloApi = useApi(MensagensApiClient.postModelo);
  const getModeloApi = useApi(MensagensApiClient.getModelo);
  const putModeloApi = useApi(MensagensApiClient.putModelo);
  const deleteModeloApi = useApi(MensagensApiClient.deleteModelo);

  //Busca mensagens ao renderizar tela
  React.useEffect(() => {
    getModelos();
  }, [getModelos]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (modelosResponse) setModelos(modelosResponse);
  }, [modelosResponse]);

  const togNovoModeloModal = () => {
    setValues({});
    setNovo(true);
    CommonsHelper.removeBodyCss();
    setModeloModal(true);
  };

  const togEditarModeloModal = async (uid) => {
    if (await setModelo(uid)) return;
    setNovo(false);
    CommonsHelper.removeBodyCss();
    setModeloModal(true);
  };

  const setModelo = async (uid) => {
    const response = await getModeloApi.request(uid);
    if (!response) return true;
    const descricaoComEmojis = emojiToolkit.shortnameToUnicode(
      response.descricao
    );
    setValues({ ...response, descricao: descricaoComEmojis });
    return false;
  };

  const salvaNovoModelo = async () => {
    const { erros, formData } = validaModelo();

    if (erros)
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postModeloApi.request(formData);
    if (!response) return;
    CommonSwal({
      title: "Novo modelo de mensagem cadastrado com sucesso!",
      icon: "success",
    }).then(() => {
      getModelos();
      setModeloModal(false);
    });
  };

  const salvaModelo = async () => {
    const { erros, formData } = validaModelo();

    if (erros)
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putModeloApi.request(values.uid, formData);
    if (!response) return;
    CommonSwal({
      title: "Modelo de mensagem salvo com sucesso!",
      icon: "success",
    }).then(() => {
      getModelos();
      setModeloModal(false);
    });
  };

  const validaModelo = () => {
    const formData = new FormData();
    var erros;

    formData.append("tipo", values?.tipo);
    formData.append("nome", values?.nome);
    formData.append("variaveis", values?.variaveis);
    formData.append("descricao", emojiToolkit.toShort(values?.descricao || ""));
    erros = Validation.verificarForm(formData);

    return { erros, formData };
  };

  const apagaModelo = async (uid) => {
    const response = await deleteModeloApi.request(uid);
    if (!response) return;
    CommonSwal({
      title: "Modelo de mensagem apagado com sucesso!",
      icon: "success",
    }).then(() => {
      getModelos();
    });
  };

  return (
    <>
      <Card>
        <ModelosDataTable
          linhas={modelos}
          togNovoModeloModal={togNovoModeloModal}
          togEditarModeloModal={togEditarModeloModal}
          apagaModelo={apagaModelo}
        />
      </Card>
      <ModeloModal
        isOpen={modeloModal}
        setIsOpen={setModeloModal}
        valuesHook={{ values, setValues }}
        salvaNovoModelo={salvaNovoModelo}
        novo={novo}
        salvaModelo={salvaModelo}
      />
    </>
  );
}

export default Modelos;
